import template from './employee_role_list.html';
import * as Utils from '../../lib/savanna_utils.js';
import tr from '../../lib/default-translator.js';

class ReportEmployeeRoleListViewModel
{
	constructor(page)
	{
		this.page = page;
		this.employee_role_list = ko.observableArray();
		this.access_roles = ko.observableArray();
		this.role_name = ko.observable('admin');
		this.loader = ko.observable(false);
		this.show_hint = ko.observable(true);
		
		// Pagination properties
		this.current_page_number = ko.observable(1);
		this.current_page_size = ko.observable(10);
		this.page_count = ko.observable(1);
		this.pagination_summary = ko.observable('');
		this.number_of_records = ko.observableArray([10, 20, 50, 100]);
		this.selected_number_of_records = ko.observable(10);
		this.total_records = ko.observable(0);
		
		// Full dataset for pagination
		this.all_employees = ko.observableArray();
		
		// Subscribe to page size changes
		this.selected_number_of_records.subscribe((newVal) => {
			this.current_page_size(newVal);
			this.current_page_number(1);
			this.updatePaginatedData();
		});
	}

	show_report_help()
	{
		Grape.dialog.open('EmployeesWithRolesHelp', { employee_id: this.page.bindings.id });
	}
	
	updatePaginatedData()
	{
		const startIndex = (this.current_page_number() - 1) * this.current_page_size();
		const endIndex = startIndex + this.current_page_size();
		const paginatedData = this.all_employees().slice(startIndex, endIndex);
		
		this.employee_role_list(paginatedData);
		this.page_count(Math.ceil(this.all_employees().length / this.current_page_size()));
		this.total_records(this.all_employees().length);
		
		this.pagination_summary(
			`Showing ${startIndex + 1} to ${Math.min(endIndex, this.all_employees().length)} of ${this.all_employees().length} entries`
		);
	}
	
	page_click(page_number)
	{
		this.current_page_number(page_number);
		this.updatePaginatedData();
	}
	
	async download_clicked()
	{
		if (this.all_employees().length === 0)
		{
			Grape.alerts.alert({
				type: 'error',
				message: tr('No data available for download.'),
				title: tr('Error')
			});
			return;
		}
		
		try
		{
			let csv_content = [];
			
			// Create header row (without Photo column)
			let header_row = ['"Name"', '"Company"', '"Department"'];
			csv_content.push(header_row.join(','));
			
			// Process all employees
			this.all_employees().forEach(employee => {
				let row = [
					`"${employee.firstname} ${employee.surname}"`,
					`"${employee.company || ''}"`,
					`"${employee.department || ''}"`
				];
				csv_content.push(row.join(','));
			});
			
			// Create and download the CSV file
			let csvString = csv_content.join('\n');
			let blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
			let link = document.createElement('a');
			
			link.href = URL.createObjectURL(blob);
			link.setAttribute('download', `employees_with_role_${this.role_name()}.csv`);
			
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		}
		catch (error)
		{
			console.error('Error downloading report:', error);
			Grape.alerts.alert({
				type: 'error',
				message: tr('Failed to download report data'),
				title: tr('Error')
			});
		}
	}
}

class ReportEmployeeRoleListPage
{
	constructor(bindings)
	{
		this.bindings = bindings;
		this.viewModel = new ReportEmployeeRoleListViewModel(this);
	}

	async init()
	{
		// check access to page
		if (await Utils.redirectOnAccessDenied('EmployeeWithRolesList'))
			return;

		document.title = tr('Employees With Roles');
		window.current_page_title(tr('Employees With Roles'));

		this.viewModel.access_roles(await Utils.getGrapeListAccessRoles());
	}

	async updateData()
	{
		this.viewModel.loader(true);
		try
		{
			let res = await Grape.fetches.postJSON('/employee/get_employees_with_role', { 'role': this.viewModel.role_name() });
			if (res.status === 'OK' && res.employees_with_role !== null)
			{
				this.viewModel.all_employees(res.employees_with_role);
				this.viewModel.current_page_number(1);
				this.viewModel.updatePaginatedData();
				this.viewModel.show_hint(false);
			}
			else
			{
				this.viewModel.all_employees.removeAll();
				this.viewModel.employee_role_list.removeAll();
			}
		}
		catch (err)
		{
			console.error(err);
		}
		this.viewModel.loader(false);
	};
}

export default {
	route: '[/]general/employee_role_list',
	page_class: ReportEmployeeRoleListPage,
	template: template,
	template_filename: 'translation/employee_role_list'
};